import styled from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { LabelStyled, SVGIconCustomStyled } from '@yme/atoms/button/styled';
import { ImageStyled } from '@yme/atoms/image';
import { colorCoreBlack300, colorCoreGray500 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { AspectRatio } from '@yme/utils/constants';
import { getTextStyles } from '@yme/utils/styles';
export const CompareProductCardStyled = styled(FlexWrapper) `
  box-sizing: border-box;
  padding: 8px;
  border: 1px solid ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.s};
  overflow: hidden;

  ${ADAPTIVE.minWidth.desktop} {
    width: 25%;
  }
`;
export const ImageWrapperStyled = styled.div `
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 68px;
  height: 52px;

  ${ImageStyled} {
    object-fit: contain;
  }
`;
export const FlexWrapperStyled = styled(FlexWrapper) `
  max-width: calc(100% - 76px);

  ${ADAPTIVE.minWidth.desktop} {
    max-width: unset;
  }

  ${ADAPTIVE.minWidth.desktopLg} {
    max-width: calc(100% - 76px);
  }
`;
export const CompareStickyBarEmptyCardStyled = styled(FlexWrapper) `
  width: 25%;
  height: 100%;
  box-sizing: border-box;
  border: 1px dashed ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.s};
  position: relative;
`;
export const CompareEmptyCardStyled = styled.div `
  border: 1px dashed ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.s};
  aspect-ratio: ${AspectRatio.VerticalRectangle};
  width: 75%;
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;

  ${ADAPTIVE.minWidth.tablet} {
    width: 35%;
  }

  ${ADAPTIVE.minWidth.desktop} {
    flex-shrink: 1;
    width: 20%;
    max-width: 244px;

    &:first-child {
      ${({ isRightToLeft }) => (isRightToLeft ? 'margin-right: 20%;' : 'margin-left: 20%;')}
    }
  }
`;
export const CompareEmptyCardContentStyled = styled(FlexWrapper) `
  height: 100%;
`;
export const ButtonStyled = styled(Button) `
  ${LabelStyled} {
    ${getTextStyles('Ubuntu', 500, 16, 24)};
    text-transform: none;
    color: ${colorCoreBlack300};
  }

  ${SVGIconCustomStyled} {
    path {
      fill: ${colorCoreBlack300};
    }
  }

  &:hover {
    background-color: transparent;
  }
`;
